import React from "react";
import { NumericFormat } from "react-number-format";

interface IProps {
  value?: number;
  [key: string]: any;
}

const CurrencyText: React.FC<IProps> = ({ value = 0, ...otherProps }) => {
  return (
    <NumericFormat
      displayType={"text"}
      valueIsNumericString
      prefix="$"
      thousandSeparator={"."}
      decimalSeparator={","}
      decimalScale={0}
      value={value}
      {...otherProps}
    />
  );
};

export default CurrencyText;
